import { render, staticRenderFns } from "./procesamiento-compra.vue?vue&type=template&id=2412dd37&"
import script from "./procesamiento-compra.vue?vue&type=script&lang=js&"
export * from "./procesamiento-compra.vue?vue&type=script&lang=js&"
import style0 from "./procesamiento-compra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports